import * as React from "react";
import { Button, Card, CardBody } from "reactstrap";
import { Spinner } from "reactstrap";
import { ReactComponent as PositiveIcon } from "../../assets/images/SATI/positive-icon.svg";
import { ReactComponent as NegativeIcon } from "../../assets/images/SATI/negative-icon.svg";

const SummaryMessages = ({ data, isLoading = false, onClickDetails }) => {
  if (isLoading)
    return (
      <React.Fragment>
        <h5 style={{ color: "#1D1F3F" }}>Resumen</h5>
        <div className="overflow-auto my-3 d-flex justify-content-center">
          <Spinner size="md" color="#316B6D" className="align-self-center" />
        </div>
      </React.Fragment>
    );

  return (
    <React.Fragment>
      {!!onClickDetails ? (
        <div className="d-flex flex-direction-row align-items-center" style={{ justifyContent: "space-between" }}>
          <h5 style={{ color: "#1D1F3F" }}>Resumen</h5>
          <Button
            className="btn btn-primary"
            style={{
              backgroundColor: "#097AAF",
              color: "white",
              borderRadius: "5px",
            }}
            onClick={onClickDetails}
          >
            Ver detalles
          </Button>
        </div>
      ) : (
        <h5 style={{ color: "#1D1F3F" }}>Resumen</h5>
      )}

      <div className="overflow-auto my-3">
        {(data?.length === 0 || !data) && (
          <Card
            style={{
              borderWidth: "1px",
              border: "0.540314px solid #1D1F3F",
              borderRadius: "16.2094px",
            }}
          >
            <CardBody>Datos insuficientes</CardBody>
          </Card>
        )}

        {data?.map(({ text, value }, index) => (
          <Card key={index}>
            <CardBody
              className="d-flex flex-row align-items-center"
              style={{
                borderWidth: "1px",
                border: "0.540314px solid #1D1F3F",
                borderRadius: "16.2094px",
                gap: "1rem",
                minHeight: "2rem"
              }}
            >
              <div style={{ height: "20px", width: "20px" }}>
                {value === "POSITIVE" ? (
                  <PositiveIcon width="20px" height="20px" />
                ) : (
                  <NegativeIcon width="20px" height="20px" />
                )}
              </div>
              <span>{text}</span>
            </CardBody>
          </Card>
        ))}
      </div>
    </React.Fragment>
  );
};

export default SummaryMessages;
